import type { ContentItem } from "@/types/content";
import type { MediaController } from "../adapters/types";
import type { AdapterProps } from "../MediaPlayerHost";
import type { RecordingState } from "../MediaContentViewer";
import { YouTubePlayer } from "./YouTubePlayer";
import { VideoPlayer } from "./VideoPlayer";
import { AudioPlayer } from "./AudioPlayer";
import { RecordingInterface } from "./RecordingInterface";

interface MediaHeaderProps {
  content: ContentItem;
  controller: MediaController | null;
  adapterProps: AdapterProps;
  onRecordingComplete?: () => void;
  onRecordingStateChange?: (state: RecordingState) => void;
}

export function MediaHeader({ content, controller, adapterProps, onRecordingComplete, onRecordingStateChange }: MediaHeaderProps) {
  const { ref, containerId, src } = adapterProps;

  switch (content.type) {
    case "youtube":
      return (
        <YouTubePlayer
          containerId={containerId!}
          controller={controller}
        />
      );

    case "video":
      return (
        <VideoPlayer
          src={src}
          videoRef={ref as React.RefObject<HTMLVideoElement>}
        />
      );

    case "recording":
      // If no src (new recording), show RecordingInterface
      if (!src && onRecordingComplete) {
        return (
          <RecordingInterface
            content={content}
            onRecordingComplete={onRecordingComplete}
            onRecordingStateChange={onRecordingStateChange}
          />
        );
      }
      // Existing recording - show AudioPlayer for playback
      return (
        <AudioPlayer
          src={src}
          audioRef={ref as React.RefObject<HTMLAudioElement>}
        />
      );

    case "audio":
      return (
        <AudioPlayer
          src={src}
          audioRef={ref as React.RefObject<HTMLAudioElement>}
        />
      );

    default:
      return null;
  }
}